import React from 'react';
import {
    AppBar,
    Dialog,
    DialogContent,
    IconButton,
    Toolbar,
} from '@mui/material';
import TermsAndConditionsPage from '../settings/terms-and-conditions';
import useTermsAndConditionsDialogStyles from '../../styles/terms-and-conditions-dialog/terms-and-conditions-dialog.style';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
    isOpen: boolean;
    onClose?: () => void;
    children?: React.ReactNode;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
};

export default function TermsAndConditionsDialog(props: Props) {
    const classes = useTermsAndConditionsDialogStyles();

    const getHeader = () => {
        if (props.onClose) {
            return (
                <AppBar className={classes.dialogHeader} elevation={0}>
                    <Toolbar>
                        <IconButton
                            size="small"
                            edge="end"
                            color="inherit"
                            onClick={props.onClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
            );
        }
    };

    return (
        <Dialog
            open={props.isOpen}
            onClose={props.onClose}
            fullWidth={true}
            maxWidth={props.maxWidth ? props.maxWidth : 'lg'}
        >
            {getHeader()}
            <DialogContent>
                <TermsAndConditionsPage />
            </DialogContent>
            {props.children}
        </Dialog>
    );
}
